// Vstupní bod aplikace. Pořadí: globální App, vrstva Supabase (window.claude),
// pak moduly aplikace. Aplikace se spustí (boot) až po načtení všech modulů.
import './app-global.js';
import './supabase-layer.js';
import './core/appearance.js';
import './core/update.js';
import './core/dashboard-config.js';
import './core/state.js';
import './core/pagination.js';
import './core/boot.js';
import './core/companies.js';
import './core/chrome.js';
import './core/sync-badge.js';
import './core/licence.js';
import './core/feedback-core.js';
import './views/dashboard.js';
import './views/my-tasks.js';
import './core/ui-kit.js';
import './core/access.js';
import './views/places.js';
import './views/audit-runner.js';
import './views/company-switcher.js';
import './views/history.js';
import './views/table.js';
import './views/corrective.js';
import './core/pdf.js';
import './views/schedule.js';
import './core/router.js';
import './main-render.js';
import { boot } from './core/boot.js';

boot();

// Service worker (dist/sw.js, vite.config.js) — jen v sestavené verzi na https.
if (import.meta.env && import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', function(){ navigator.serviceWorker.register('/sw.js').catch(function(){}); });
}
